import { Box, BoxProps } from "@chakra-ui/react"

type DepositCarouselItemContainerProps = BoxProps & {
  isActive: boolean
}

export default function DepositCarouselItemContainer({
  isActive,
  children,
  ...props
}: DepositCarouselItemContainerProps) {
  return (
    <Box
      color="primary.white.100"
      cursor={isActive ? "auto" : "pointer"}
      opacity={isActive ? "1" : "0.1"}
      transition="opacity 500ms linear"
      {...props}
    >
      <Box
        height="100%"
        width="100%"
        backgroundColor="primary.black.100"
        borderRadius="8px"
        boxShadow="0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 4px 9px 0px rgba(0, 0, 0, 0.10);"
        p="26px 32px"
      >
        {children}
      </Box>
    </Box>
  )
}
